import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          关于屁屁影院的常见疑问解答
        </p>

        <div className="mt-10 space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="font-heading text-base font-bold text-foreground-950 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 mt-0.5 rounded-full bg-primary-100 flex items-center justify-center text-xs text-primary-600 font-bold">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="mt-3 pl-9 text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}